import React, {FC} from 'react';
import { Routes, Route } from 'react-router-dom';
import '@garpix/garpix-web-components/dist/garpix-web-components/garpix-web-components.css';
import { useStoreon } from 'storeon/react';
import Paths from '../const/paths';
import { Combine } from '../pages';
import SocketLayoutCall from './SocketLayoutCall';
import Modals from './Modals';
import ModalPhoneCall from './ModalPhoneCall';

export const App: FC = ({ context }: any) => {
  const { dispatch, showModalCall } = useStoreon('showModalCall');

  return (
    <SocketLayoutCall roomId=''>
      {() => {
        return (
          <>
            <Routes>
              <Route
                path={Paths.ALL.path}
                element={<Combine staticContext={context} {...Paths.ALL} />}
              />

            </Routes>
            <Modals />
            {showModalCall && <ModalPhoneCall flag={showModalCall} onRequestClose={()=>dispatch('modalCall/show', false)} />}
          </>
        );
      }}
    </SocketLayoutCall>
  );
};

export default App;
